import React, { useState } from "react";
import Layout from "../Layout/Layout";
import { Link } from "react-router-dom";
import "./style.css";
import searchIcon from "../../assets/search-icon.png";

function SearchUi({
  setTableQaury,
  tableQaury,
  placeHolder,
  buttonName,
  buttonBoolean,
  linkPath,
  backgroundColor
}) {
  const [search,setSearch] = useState("")
  return (
    <div className="d-flex justify-content-between mb-0 align-items-start prent-sreach">
      <div className={`d-flex justify-content-between align-items-start dt-layout-start prent-sreach `}>
        <div className="dt-search ">
          {/* <label htmlFor="dt-search-0 " className="filters_label">
            Search:
          </label> */}
          <div className="search-input-container">
            <span className="search-icon">
              <img src={searchIcon} alt="search-icon" />
            </span>
          <input
            type="search"
            className="form-control search-input"
            id="dt-search-0"
            placeholder={placeHolder}
            aria-controls="DataTables_Table_0"
            onChange={(e) =>
              // setSearch(e.target.value)
              setTableQaury({
                ...tableQaury,
                search: e.target.value,
                currentPage: 1,
              })
            }
            style={{backgroundColor:'#F9FAFB'}}
          />
          </div>
        </div>
        {/* <button className="serach-btn ml-3" onClick={()=>setTableQaury({
                ...tableQaury,
                search: search,
                currentPage: 1,
              })}>Search</button> */}
      </div>
        {buttonBoolean ? (
          buttonName ? (
            <div className={`d-flex justify-content-end align-items-start `} style={{minWidth:"130px"}}>
            <>
              <Link to={linkPath} >
                <button className="blue-btn mt-0 ">{buttonName}</button>
              </Link>
            </>
      </div>
          ) : (
            null
          )
        ) : (
          null
        )}
    </div>
  );
}

export default SearchUi;
